export const en = {
    'banner-image-desc1':
        'Relevant images make your ads more appealing and help users understand your offer more quickly.',
    'banner-image-desc2':
        'We recommend you create two versions of each ad: with a standard image (aspect ratio from 1:1 to 4:3/3:4) and with a wide-format image (16:9). This way your ads will be served on all available sites.',
    'normal-view-title': 'Add images to ads',
    'normal-view-title-hint': 'Shown because you have ads without images',
    'popup-view-title': 'Add images to your ad',
    'popup-view-title-hint': 'Shown because your ad has no images',
    'show-many-banner-button': 'View {count} ads',
    'show-one-banner-button': 'View {count} ad',
    'show-some-banner-button': 'View {count} ads',
    'with-image': 'With an image',
    'without-image': 'Without an image'
};
